import React from 'react'
import { BadgeSkeleton } from 'src/component/ui/badge/badge-skeleton'
import { Skeleton } from 'src/component/ui/skeleton'
import { cn } from 'src/lib/utils'

interface WorkoutCardSkeletonProps {
  className?: string
  aspectRatio?: string
}

export const WorkoutCardSkeleton = ({
  className,
  aspectRatio = 'aspect-[16/9]',
}: WorkoutCardSkeletonProps): React.ReactElement => {
  return (
    <div data-testid="workout-card-skeleton" className={cn('relative overflow-hidden rounded-md w-full h-full', className)}>
      <div className={cn('w-full h-full', aspectRatio)}>
        <Skeleton className="w-full h-full bg-tertiary-grey rounded-md" />
        <div className="absolute inset-0 flex flex-col justify-end p-3">
          <Skeleton className="w-32 h-10 bg-primary-gray mb-3" />
          <div className="flex gap-3 justify-between items-center">
            <Skeleton className="w-24 h-7 bg-primary-gray" />
            <BadgeSkeleton />
          </div>
        </div>
      </div>
    </div>
  )
}
